module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_agder_neg.8fd0fc71.png";